import { useState, useEffect } from "react";
import { isEmpty, pick } from "lodash";
import { useLocation } from "react-router-dom";
import { apiPost, apiGet } from "../Utils/apiFetch";
import { apiPath } from "../Utils/apiPath";
import { createContext } from "use-context-selector";
import { showAlert } from "../Utils/Constant";
import { toast } from "react-toastify";
import { jwtDecode } from "jwt-decode";
const AuthContext = createContext();

export default AuthContext;

export const AuthProvider = ({ children }) => {
  // const navigate = useNavigate();
  const [isRefereshLoader, setRefereshLoader] = useState(false);
  const [bellSound, setBellSound] = useState(false);
  const [count, setCount] = useState({});
  const [agentId, setAgentId] = useState("");
  let [user, setUser] = useState(() =>
    localStorage.getItem("token")
      ? jwtDecode(localStorage.getItem("token"))
      : null,
  );
  const [user_coins, setUserCoins] = useState(0);
  const getCoins = async () => {
    setRefereshLoader(true);
    const { status, data } = await apiGet(apiPath.refreshAmount);
    if (status === 200) {
      if (data.success) {
        setUserCoins(data.results.totalCoins);
        setRefereshLoader(false);
      } else {
        toast.error(data.message);
        setRefereshLoader(false);
      }
    } else {
      toast.error("API Error");
      setRefereshLoader(false);
    }
  };

  useEffect(() => {
  const msg = sessionStorage.getItem("loginSuccessMsg");
  if (msg) {
    showAlert(msg);
    sessionStorage.removeItem("loginSuccessMsg"); // so it shows only once
  }
}, []);
  // useEffect(() => {
  //   if (isEmpty(user)) return;

  //   getCount();
  //   const intervalCall = setInterval(getCount, 15000);

  //   return () => clearInterval(intervalCall);
  // }, [user]);

  // useEffect(() => {
  //   if (!isEmpty(user)) {
  //     if (user?.userType == "owner" || user?.userType == "sub_owner") {
  //       getCount();
  //     }
  //   }
  // }, [user]);
  useEffect(() => {
    if (!isEmpty(user)) {
      getCoins();
    }
  }, [user]);
  let logoutUser = () => {
    setUser(null);
    localStorage.removeItem("token");
    localStorage.removeItem("refresh_token");
    // toast.success("Log Out Succesfully");
    showAlert("Logged Out Successfully");
    // navigate("/login");
  };

  let contextData = {
    user,
    setUser,
    user_coins,
    setUserCoins,
    logoutUser,
    getCoins,
    isRefereshLoader,
    setRefereshLoader,
    count,
    setCount,
    agentId,
    setAgentId,
  };

  return (
    <AuthContext.Provider value={contextData}>{children}</AuthContext.Provider>
  );
};
